module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-10-sm-1e51f1bab3f23c8db3ef9d7241e1fdad.png";